import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import GlobalModal from 'components/modals/GlobalModal';
import GlobalToast from 'components/GlobalToast';
import SideNav from 'routes/profile/nav/SideNav';
import Header from 'routes/profile/layout/Header';
import GlobalLoader from 'routes/profile/common/loading/GlobalLoader';
import Page from './layout/Page';
import ReferralLink from './components/ReferralLink';
import RewardsTracker from './components/RewardsTracker';
import HowItWorks from './components/HowItWorks';
import useCdpPageTracking from 'utils/custom-react-hooks/useCdpPageTracking';
import { viewReferralsProperties } from 'services/tracking/cdp/events/referrals';
import { ErrorBoundary } from 'react-error-boundary';
import { logReferralError } from './utils/error';
import SomethingWentWrong from 'routes/merchant-scoped-portal/components/alerts/SomethingWentWrong';

const Refer: React.FC = () => {
  const areAnonymousFlagsLoaded = useSelector(
    (state: AppState) => state.feature.areAnonymousFlagsLoaded
  );

  useCdpPageTracking({
    didLoadingFail: false,
    isLoading: !areAnonymousFlagsLoaded,
    properties: viewReferralsProperties(),
  });

  if (!areAnonymousFlagsLoaded) {
    return <GlobalLoader />;
  }

  return (
    <div className={'flex flex-col h-screen'}>
      <Header />
      <div className={'md:flex grow'}>
        <GlobalModal />
        <GlobalToast />
        <div
          className={
            'hidden md:block flex-none w-64 px-4 py-6 shadow-rightDivider'
          }
        >
          <SideNav showSignOut={false} />
        </div>
        <div className="flex-1 overflow-y-auto">
          <ErrorBoundary
            fallback={
              <Page>
                <SomethingWentWrong
                  type="page"
                  onTryAgain={() => window.location.reload()}
                />
              </Page>
            }
            onError={(error) => logReferralError(error)}
          >
            <Page>
              <ReferralLink />
              <RewardsTracker />
              <HowItWorks />
            </Page>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default Refer;
